document.addEventListener('DOMContentLoaded', () => {
  $('#ranks-table').DataTable({
    fixedHeader: true,
    pageLength: 100,
    order: []
  })
})
